export interface ModuleStats {
  inventory: { items: number; discontinued: number };
  purchases: { bills: number; lines: number };
  hr:        { employees: number; attendance: number; leaves: number; salaries: number };
  masters:   { brands: number; colors: number; sizes: number; categories: number };
}

export async function getModuleStats(): Promise<ModuleStats> {
  const r = await fetch('/api/modules/stats', { credentials: 'include' });
  if (!r.ok) throw new Error(`stats failed (${r.status})`);
  return r.json() as Promise<ModuleStats>;
}
